module.exports = __webpack_public_path__ + "img/ham_icon_005.6f9917f4.png";